






















import { Component, Vue, Model, Watch } from 'vue-property-decorator'
import IColor from '@/models/IColor'
import colors from '@/data/colors'
import { findContrastColor } from '../utils'

@Component
export default class ColorPicker extends Vue {
  @Model('input', { type: String, required: false })
  public color!: string | null
  public localColor: string | null = null
  public colorLabel: string | null = null
  public colors: IColor[] = colors

  public mounted(): void {
    this.localColor = this.color
    if (this.color) {
      const color: IColor | undefined = this.colors.find(
        (c: IColor) => c.value === this.color
      )
      if (color) {
        this.colorLabel = color.label
      }
    } else {
      this.localColor = this.colors[0].value
    }
  }

  public select(color: IColor): void {
    this.localColor = color.value
    this.colorLabel = color.label
  }

  public colorBackground(color: IColor): any {
    return {
      border: !color.label ? '1px solid #95afc0' : '',
      backgroundColor: color.value
    }
  }

  public get background(): any | null {
    if (!this.localColor) {
      return null
    }
    return {
      'background-color': this.localColor
    }
  }

  public get colorStyle() {
    return {
      color: findContrastColor(this.localColor)
    }
  }

  @Watch('localColor')
  public onColorChange(color: string | null, oldColor: string | null) {
    if (this.color !== color) {
      this.$emit('input', color)
      this.$emit('color-change')
    }
  }
}
